var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          class: { notInDrawer: !_vm.getModalStatus(), wrapper: true },
          on: { click: _vm.doClose },
        },
        [
          _c(
            "div",
            {
              class: { wrapper_body: true },
              attrs: { id: "globalCustomModal" },
            },
            [
              _c(
                "div",
                { class: { modal_body: true, small: true } },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-default btn-sm position-absolute close_btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.doClose(null, true)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-close" })]
                  ),
                  _vm._v(" "),
                  _vm._t("default"),
                ],
                2
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }